import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_NEW_EFFORT_REPORT} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const NewEffortReport = lazy(() =>
  import('../../../screens/NewEffortReport')
    .then(module => ({default: module.NewEffortReport})));

const NewEffortReportNavigation = [
  {
    path: ROUTE_NEW_EFFORT_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <NewEffortReport />
      </Suspense>
    ),
  },
];

export default NewEffortReportNavigation;
